<template>
    <el-container direction="vertical">
        <el-row class="income-header">
            <el-col :xs="24" :sm="24" :md="24" :lg="16">
                <div class="income-subtitle">
                    ID {{ income.id }} (создан {{ income.created_by_name }} {{ income.created_at }})
                </div>
                <div class="income-title">
                    Карточка @ прихода
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="8" class="actions">
                <template v-if="isCanEditIncome">
                    <template v-if="isEdit">
                        <span class="action-title action-edit" @click="save">
                            Сохранить
                        </span>
                    </template>
                    <template v-else>
                        <span class="action-title action-edit" @click="edit">
                            Редактировать
                        </span>
                    </template>
                </template>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <div class="income-main" v-loading="loadingMain">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="24" :lg="5">
                    <el-row>
                        <el-col :span="10" class="gray">
                            Статус
                        </el-col>
                        <el-col :span="14">
                            {{ operationStatusName }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Вид оплаты
                        </el-col>
                        <el-col :span="14">
                            {{ payTypeName }}
                        </el-col>
                    </el-row>
                    <template v-if="income.received_from_type !== localReferences.incomeRecievedFromType.employer">
                        <el-row>
                            <el-col :span="10" class="gray">
                                Статья
                            </el-col>
                            <el-col :span="14">
                                <template v-if="isEdit">
                                    <el-select
                                        v-model="income.detail_id"
                                        placement="bottom"
                                        popper-class="popper-dropdown"
                                        size="mini"
                                    >
                                        <el-option v-for="item in detailsList" :key="item.id" :label="item.name" :value="item.id" />
                                    </el-select>
                                    <div class="field-error bold" v-if="errors.detail_id" v-text="errors.detail_id[0]"></div>
                                </template>
                                <template v-else>
                                    {{ income.detail_name }}
                                </template>
                            </el-col>
                        </el-row>
                    </template>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Дата поступления
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <el-date-picker
                                    v-model="income.date"
                                    type="date"
                                    placeholder="дд.мм.гггг"
                                    format="dd.MM.yyyy"
                                    value-format="dd.MM.yyyy"
                                    :picker-options="pickerOptions"
                                    :clearable="false"
                                    size="mini"
                                    class="w100"
                                />
                                <div class="field-error bold" v-if="errors.date" v-text="errors.date[0]"></div>
                            </template>
                            <template v-else>
                                {{ income.date }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Сумма, руб
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <auto-numeric
                                    v-model="income.amount"
                                    :options="numericOptions"
                                    :class="[
                                        { 'red': isDebtsMeasurerVisible && !isIncomeAmountEquivDebtsAmount },
                                        'autonumeric'
                                    ]"
                                />
                                <div class="field-error bold" v-if="errors.amount" v-text="errors.amount[0]"></div>
                                <div v-else-if="!isIncomeAmountEquivDebtsAmount && debts.length" class="field-error bold">
                                    {{ amountErrorMessage }}
                                </div>
                            </template>
                            <template v-else>
                                {{ formatFinance(income.amount) }}
                            </template>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="11">
                    <el-row>
                        <el-col :span="10" class="gray">
                            Принял – тип контрагента
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit && isIncomeCashDirector">
                                <el-select
                                    v-model="income.received_by_type"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    size="mini"
                                >
                                    <el-option v-for="item in receivedByTypesList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <div class="field-error bold" v-if="errors.received_by_type" v-text="errors.received_by_type[0]"></div>
                            </template>
                            <template v-else>
                                {{ receivedByTypeName }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Принял
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <el-select
                                    v-model="income.received_by_id"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    filterable
                                    :disabled="dealIdParam !== null && isIncomeCashEmployer"
                                    autocomplete
                                    size="mini"
                                >
                                    <el-option v-for="item in receivedByIdList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <div class="field-error bold" v-if="errors.received_by_id" v-text="errors.received_by_id[0]"></div>
                            </template>
                            <template v-else>
                                {{ income.received_by_name }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Получено у – тип контрагента
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <el-select
                                    v-model="income.received_from_type"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    size="mini"
                                    :disabled="dealIdParam !== null"
                                >
                                    <el-option v-for="item in receivedFromTypesList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                                <div class="field-error bold" v-if="errors.received_from_type" v-text="errors.received_from_type[0]"></div>
                            </template>
                            <template v-else>
                                {{ receivedFromTypeName }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Получено у
                        </el-col>
                        <el-col :span="14">
                            <template v-if="isEdit">
                                <template v-if="receivedFromType === 'contact'">
                                    <el-select
                                        v-model="income.received_from_id"
                                        placement="bottom"
                                        popper-class="popper-dropdown"
                                        filterable
                                        remote
                                        reserve-keyword
                                        :remote-method="searchReceivedFrom"
                                        :automatic-dropdown="true"
                                        @change="handleSelectContact"
                                        size="mini"
                                        placeholder="Укажите номер договора"
                                        :disabled="dealIdParam !== null"
                                    >
                                        <el-option v-for="(item, index) in receivedFromIdList" :key="item.id + '_' +index" :label="item.name" :value="item.id" />
                                    </el-select>
                                </template>
                                <template v-else>
                                    <el-select
                                        v-model="income.received_from_id"
                                        placement="bottom"
                                        popper-class="popper-dropdown"
                                        filterable
                                        autocomplete
                                        size="mini"
                                    >
                                        <el-option v-for="item in employersList" :key="item.id" :label="item.name" :value="item.id" />
                                    </el-select>
                                </template>
                                <div class="field-error bold" v-if="errors.received_from_id" v-text="errors.received_from_id[0]"></div>
                            </template>
                            <template v-else-if="Object.keys(selectedContact).length && receivedFromType === 'contact'">
                                {{ selectedContact.name }}
                            </template>
                            <template v-else-if="receivedFromType === 'employer'">
                                {{ receivedFromIdName }}
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <template v-if="Object.keys(selectedContact).length">
                                <span class="gray">Сделка </span><a class="link" target="_blank" :href="getDealLink(selectedContact.deal_id)">#{{ selectedContact.deal_id }}</a>,
                                {{ selectedContact.contact_name }} {{ selectedContact.contact_phone }} {{ selectedContact.address }}
                            </template>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="8">
                    <el-row>
                        <el-col class="gray pt10">
                            Комментарий
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <template v-if="isEdit">
                                <el-input
                                    size="mini"
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder=""
                                    v-model="income.comment"
                                />
                                <div class="error" v-if="errors.comment">
                                    {{ errors.comment[0] }}
                                </div>
                            </template>
                            <template v-else>
                                <div v-format-text="income.comment">
                                </div>
                            </template>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <template v-if="isNew && isEdit">
            <div class="income-debts" v-show="isDebtsMeasurerVisible">
                <h3>
                    Долги {{ receivedFromIdName }} по сделкам
                </h3>
                <div class="incomes-debts-grid" v-loading="loadingDebts">
                    <template v-for="(column, index) in debtsMeasurerColumns">
                        <div :key="'header_' + index" class="header-cell">
                            {{ column.headerName }}
                        </div>
                    </template>
                    <template v-for="(debt, debtIndex) in debts">
                        <template v-for="(column, columnIndex) in debtsMeasurerColumns">
                            <div
                                :key="debtIndex+ '_'+ columnIndex"
                                :class="column.fieldClass"
                                :title="debt[column.field]"
                            >
                                <template v-if="column.field === 'debt_paid'">
                                    <el-checkbox v-model="debt[column.field]" @change="handleDebtPaid(debt)" />
                                </template>
                                <template v-else-if="column.field === 'deal_id'">
                                    <a :href="getDealLink(debt[column.field])" target="_blank" class="link">
                                        {{ debt[column.field] }}
                                    </a>
                                </template>
                                <template v-else-if="column.field === 'debt'">
                                    <span :class="{'red': debt.debt < 0}">
                                        {{ formatFinance(debt[column.field]) }}
                                    </span>
                                </template>
                                <template v-else-if="column.field === 'amount'">
                                    <auto-numeric
                                        v-model="debt[column.field]"
                                        :options="[numericOptions, getNumericOptionsForDebt(debt)]"
                                        class="autonumeric"
                                    />
                                </template>
                                <template v-else-if="column.field === 'comment'">
                                    <el-input
                                        size="mini"
                                        type="textarea"
                                        :rows="1"
                                        placeholder=""
                                        v-model="debt[column.field]"
                                    />
                                </template>
                                <template v-else>
                                    {{ debt[column.field] }}
                                </template>
                            </div>
                        </template>
                    </template>
                </div>
                <div
                    :class="[
                        'debts-total',
                        { 'green bold': isIncomeAmountEquivDebtsAmount },
                        { 'red bold': !isIncomeAmountEquivDebtsAmount }
                    ]"
                    v-if="debts.length"
                >
                    Сумма прихода итого: {{ formatFinance(debtsTotalAmount) }} руб.
                </div>
            </div>
            <div class="income-debts" v-show="isDebtsInstallerVisible">
                <h3>
                    Долги монтажника {{ receivedFromIdName }} по сделкам
                </h3>
                <div class="incomes-installer-debts-grid" v-loading="loadingDebts">
                    <template v-for="(column, index) in debtsInstallerColumns">
                        <div :key="'header_' + index" class="header-cell">
                            <span v-if="column.field === 'debt_paid'">
                                <el-checkbox v-model="allDebtPaid" @change="handleAllDebtPaid(allDebtPaid)" />
                            </span>
                            {{ column.headerName }}
                        </div>
                    </template>
                    <template v-for="(debt, debtIndex) in debts">
                        <template v-for="(column, columnIndex) in debtsInstallerColumns">
                            <div
                                :key="debtIndex+ '_'+ columnIndex"
                                :class="column.fieldClass"
                                :title="debt[column.field]"
                            >
                                <template v-if="column.field === 'debt_paid'">
                                    <el-checkbox v-model="debt[column.field]" @change="handleDebtPaid(debt)" />
                                </template>
                                <template v-else-if="column.field === 'deal_id'">
                                    <a :href="getDealLink(debt[column.field])" target="_blank" class="link">
                                        {{ debt[column.field] }}
                                    </a>
                                </template>
                                <template v-else-if="['salary', 'salary_paid', 'installer_balance'].includes(column.field)">
                                    {{ formatFinance(debt[column.field]) }}
                                </template>
                                <template v-else-if="column.field === 'garbage_removal'">
                                    <template v-if="debt.garbage_removal_exists">
                                        {{ formatFinance(debt[column.field]) }}
                                    </template>
                                    <template v-else>
                                        <auto-numeric
                                            v-model="debt[column.field]"
                                            :options="[numericOptions, getNumericOptionsForExpense(debt)]"
                                            @input="calculateDebt(debt)"
                                            class="autonumeric"
                                        />
                                    </template>
                                </template>
                                <template v-else-if="column.field === 'additional_work'">
                                    <template v-if="debt.additional_work_exists">
                                        {{ formatFinance(debt[column.field]) }}
                                    </template>
                                    <template v-else>
                                        <auto-numeric
                                            v-model="debt[column.field]"
                                            :options="[numericOptions, getNumericOptionsForExpense(debt)]"
                                            @input="calculateDebt(debt)"
                                            class="autonumeric"
                                        />
                                    </template>
                                </template>
                                <template v-else-if="column.field === 'visit'">
                                    <template v-if="debt.visit_exists">
                                        {{ formatFinance(debt[column.field]) }}
                                    </template>
                                    <template v-else>
                                        <auto-numeric
                                            v-model="debt[column.field]"
                                            :options="[numericOptions, getNumericOptionsForExpense(debt)]"
                                            @input="calculateDebt(debt)"
                                            class="autonumeric"
                                        />
                                    </template>
                                </template>
                                <template v-else-if="column.field === 'debt'">
                                    <span :class="{'red': debt.debt < 0}">
                                        {{ formatFinance(debt[column.field]) }}
                                    </span>
                                </template>
                                <template v-else-if="column.field === 'amount'">
                                    <auto-numeric
                                        v-model="debt[column.field]"
                                        :options="[numericOptions, getNumericOptionsForDebt(debt)]"
                                        class="autonumeric"
                                    />
                                </template>
                                <template v-else-if="column.field === 'comment'">
                                    <el-input
                                        size="mini"
                                        type="textarea"
                                        :rows="1"
                                        placeholder=""
                                        v-model="debt[column.field]"
                                    />
                                </template>
                                <template v-else>
                                    {{ debt[column.field] }}
                                </template>
                            </div>
                        </template>
                    </template>
                </div>
                <div
                    :class="[
                        'debts-total',
                        { 'green bold': isIncomeAmountEquivDebtsAmount },
                        { 'red bold': !isIncomeAmountEquivDebtsAmount }
                    ]"
                    v-if="debts.length"
                >
                    Сумма прихода итого: {{ formatFinance(debtsTotalAmount) }} руб.
                </div>
            </div>
            <div class="income-deals" v-show="isMeasurerSelectedNewCard && deals.length">
                <h3>Есть договор, но нет приходов у замерщика</h3>
                <div class="incomes-deals-grid" v-loading="loadingDeals">
                    <template v-for="(column, index) in dealsColumns">
                        <div :key="'header_' + index" class="header-cell">
                            {{ column.headerName }}
                        </div>
                    </template>
                    <div class="header-cell">
                        Создать приход
                    </div>
                    <template v-for="(deal, dealIndex) in deals">
                        <template v-for="(column, columnIndex) in dealsColumns">
                            <div
                                :key="dealIndex+ '_'+ columnIndex"
                                :class="column.fieldClass"
                                :title="deal[column.field]"
                            >
                                <template v-if="column.field === 'deal_id'">
                                    <a :href="getDealLink(deal[column.field])" target="_blank" class="link">
                                        {{ deal[column.field] }}
                                    </a>
                                </template>
                                <template v-else-if="column.field === 'prepay'">
                                    {{ formatFinance(deal[column.field]) }}
                                </template>
                                <template v-else>
                                    {{ deal[column.field] }}
                                </template>
                            </div>
                        </template>
                        <div :key="'save_' + dealIndex" class="grid-cell">
                            <template v-if="deal.prepay">
                                <font-awesome-icon icon="save" class="save-icon" @click="createDealIncome(deal)" />
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </el-container>
</template>

<script>
import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import IncomeMixin from '@/mixins/income';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import '@/assets/styles/card.scss';
import '@/assets/styles/incomes.scss';
import localReferences from '@/helpers/localReferences';

library.add(faSave);
const initialCashIncome = {
    id: null,
    operation_type_id: null,
    created_by_id: null,
    created_at: moment().format('DD.MM.YYYY HH:mm'),
    date: moment().format('DD.MM.YYYY'),
    operation_status_id: null,
    received_by_type: null,
    received_by_id: null,
    received_from_type: null,
    received_from_id: null,
    pay_type_id: null,
    detail_id: null,
    deal_id: null,
    amount: 0,
    comment: null,
    operation_status_name: '',
    operation_type_name: '',
    pay_type_name: '',
    received_by_name: '',
    received_from_name: '',
    created_by_name: '',
    amount_formatted: ''
};

export default {
    name: 'IncomeCashCard',
    components: {
        AutoNumeric
    },
    mixins: [
        IncomeMixin
    ],
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            debtsMeasurerColumns: [
                { headerName: 'Id сделки', field: 'deal_id', fieldClass: 'grid-cell' },
                { headerName: 'Дата создания', field: 'deal_created_at', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Клиент', field: 'contact_name', fieldClass: 'grid-cell' },
                { headerName: 'Телефон клиента', field: 'contact_phone', fieldClass: 'grid-cell' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Долг', field: 'debt', fieldClass: 'grid-cell' },
                { headerName: 'Долг погашен', field: 'debt_paid', fieldClass: 'grid-cell' },
                { headerName: 'Сумма прихода', field: 'amount', fieldClass: 'grid-cell' },
                { headerName: 'Комментарий', field: 'comment', fieldClass: 'grid-cell' }
            ],
            debtsInstallerColumns: [
                { headerName: 'Id сделки', field: 'deal_id', fieldClass: 'grid-cell' },
                { headerName: 'Дата создания', field: 'deal_created_at', fieldClass: 'grid-cell' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell cut-text' },
                { headerName: 'Клиент', field: 'contact_name', fieldClass: 'grid-cell cut-text' },
                { headerName: 'Телефон клиента', field: 'contact_phone', fieldClass: 'grid-cell' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell cut-text' },
                { headerName: 'Остаток по Монтажу', field: 'installer_balance', fieldClass: 'grid-cell' },
                { headerName: 'ЗП к выдаче', field: 'salary', fieldClass: 'grid-cell' },
                { headerName: 'ЗП выдано ранее', field: 'salary_paid', fieldClass: 'grid-cell' },
                { headerName: 'Вывоз мусора', field: 'garbage_removal', fieldClass: 'grid-cell' },
                { headerName: 'Допы', field: 'additional_work', fieldClass: 'grid-cell' },
                { headerName: 'Выезд', field: 'visit', fieldClass: 'grid-cell' },
                { headerName: 'Долг', field: 'debt', fieldClass: 'grid-cell' },
                { headerName: 'Долг погашен', field: 'debt_paid', fieldClass: 'grid-cell' },
                { headerName: 'Сумма прихода', field: 'amount', fieldClass: 'grid-cell' },
                { headerName: 'Комментарий', field: 'comment', fieldClass: 'grid-cell' }
            ],
            dealsColumns: [
                { headerName: 'Id сделки', field: 'deal_id', fieldClass: 'grid-cell' },
                { headerName: 'Дата создания', field: 'created_at', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Клиент', field: 'contact_name', fieldClass: 'grid-cell' },
                { headerName: 'Телефон клиента', field: 'contact_phone', fieldClass: 'grid-cell' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Предоплата', field: 'prepay', fieldClass: 'grid-cell' }
            ],
            debts: [],
            deals: [],
            income: { ...initialCashIncome },
            errors: [],
            loadingMain: false,
            loadingDebts: false,
            loadingDeals: false,
            selectedContact: {},
            amountErrorMessage: 'Сумма прихода не совпадает с суммой списания долга по сделкам',
            isSaveButtonPressed: false,
            allDebtPaid: false
        };
    },
    computed: {
        isNew() {
            return this.id === 'new' || this.id === 0;
        },
        isEdit() {
            return this.$route.meta.editMode && this.isCanEditIncome;
        },
        dealIdParam() {
            return this.$route.params.dealId || null;
        },
        measurerIdList() {
            return this.$store.state.references.measurers.map(measurer => measurer.id);
        },
        installerIdList() {
            return this.$store.state.references.installers.map(installer => installer.id);
        },
        receivedByIdList() {
            if (this.receivedByType === 'cash') {
                return this.cashesList;
            }
            if (this.receivedByType === 'employer') {
                return this.employersList;
            }
            if (this.receivedByType === 'factory') {
                return this.factoriesList;
            }
            return [];
        },
        cashesList() {
            return this.$store.state.references.cashes.filter(cash => this.localReferences.payTypesCash.includes(cash.pay_type_category_id));
        },
        amount() {
            return this.income.amount;
        },
        debtsTotalAmount() {
            return this.debts.reduce((sum, debt) => sum + debt.amount, 0);
        },
        receivedByType() {
            return this.income.received_by_type;
        },
        receivedById() {
            return this.income.received_by_id;
        },
        receivedFromType() {
            return this.income.received_from_type;
        },
        receivedFromId() {
            return this.income.received_from_id;
        },
        payTypeName() {
            return this.getNameFromListById(this.payTypesList, this.income.pay_type_id);
        },
        operationStatusName() {
            return this.getNameFromListById(this.operationStatusesList, this.income.operation_status_id);
        },
        receivedByTypeName() {
            return this.getNameFromListById(this.receivedByTypesList, this.receivedByType);
        },
        receivedFromTypeName() {
            return this.getNameFromListById(this.receivedFromTypesList, this.receivedFromType);
        },
        receivedFromIdName() {
            const list = this.receivedFromType === 'employer' ? this.employersList : this.receivedFromIdList;
            return this.getNameFromListById(list, this.receivedFromId);
        },
        isCanEditIncome() {
            if (this.isIncomeCashDirector) {
                return true;
            }
            if (this.isIncomeCashEmployer) {
                //Сотрудник не может редактировать приход где он отдал, но сам приход создан не им
                return !(this.income.received_from_type === 'employer' &&
                    this.income.received_from_id === this.$store.state.auth.employerId &&
                    this.income.created_by_id !== this.$store.state.auth.employerId);
            }
            return false;
        },
        isIncomeCashEmployer() {
            return this.$store.getters.isIncomeCashEmployer;
        },
        isIncomeCashDirector() {
            return this.$store.getters.isIncomeCashDirector;
        },
        isDebtsMeasurerVisible() {
            return this.receivedFromType === 'employer' && this.receivedFromId && !this.isInstallerSelectedNewCard;
        },
        isDebtsInstallerVisible() {
            return this.isInstallerSelectedNewCard;
        },
        isIncomeAmountEquivDebtsAmount() {
            if (this.debts.length && this.debtsTotalAmount >= 0) {
                return this.income.amount === this.debtsTotalAmount;
            }
            return true;
        },
        isInstallerSelectedNewCard() {
            return this.isNew && this.receivedFromType === 'employer' && this.installerIdList.includes(this.receivedFromId);
        },
        isMeasurerSelectedNewCard() {
            return this.isNew && this.receivedFromType === 'employer' && this.measurerIdList.includes(this.receivedFromId);
        }
    },
    beforeMount() {
        if (this.isNew) {
            this.income.created_by_id = this.$store.state.auth.employerId;
            this.income.created_by_name = this.$store.state.auth.name;
            this.income.operation_status_id = this.localReferences.operationStatuses.executed;
            this.income.operation_type_id = this.localReferences.operationTypes.deal;
            this.income.pay_type_id = this.localReferences.payTypesFull.cash;
            if (this.isIncomeCashEmployer) {
                this.income.received_by_type = 'employer';
                this.income.received_by_id = this.$store.state.auth.employerId;
            }
            if (this.dealIdParam) {
                this.getDealById(this.dealIdParam);
                this.income.received_from_type = 'contact';
            }
        }
    },
    mounted() {
        if (!this.isNew) {
            this.getIncome();
        }
    },
    methods: {
        edit() {
            if (this.isCanEditIncome) {
                this.$router.push({ name: 'income-cash-card', params: { id: '' + this.income.id } });
            }
        },
        save() {
            if (this.isSaveButtonPressed) {
                return;
            }
            this.isSaveButtonPressed = true;
            if (this.isNew) {
                if (this.debts.length) {
                    if (this.isIncomeAmountEquivDebtsAmount) {
                        if (this.isInstallerSelectedNewCard) {
                            this.createIncomesFromContactToInstaller();
                        } else {
                            this.createDebtsIncomes();
                        }
                    } else {
                        this.errors = { amount: [this.amountErrorMessage] };
                        this.$message({
                            showClose: true,
                            message: this.amountErrorMessage,
                            type: 'error',
                            duration: 5000,
                            customClass: this.alertClass()
                        });
                        this.isSaveButtonPressed = false;
                    }
                } else {
                    this.createIncome();
                }
            } else {
                this.updateIncome();
            }
        },
        close() {
            if (this.isNew) {
                this.$router.go(-1);
            }
            if (this.isEdit) {
                this.$router.push({ name: 'income-cash-card-view', params: { id: '' + this.income.id } });
            } else {
                this.$router.push({ name: 'incomes-cash' });
            }
        },
        getDealById(dealId) {
            this.$store.dispatch('deals/getDealById', dealId).then(
                response => {
                    const contractDate = response.contract_date ? `от ${response.contract_date}` : 'дата договора не указана';
                    const contractNumber = response.contract_number.length ? response.contract_number : 'номер договора не указан, ';
                    this.receivedFromIdList = [Object.assign({}, {
                        id: response.contact_id,
                        name: `${contractNumber} ${contractDate}`,
                        deal_id: response.id,
                        contract_number: response.contract_number,
                        contract_date: response.contract_date,
                        contact_name: response.contact ? response.contact.name : '',
                        contact_phone: response.contact ? response.contact.main_phone_number : '',
                        address: response.address
                    })];
                    this.income.deal_id = response.id;
                    this.income.received_from_id = response.contact_id;
                });
        },
        getNameFromListById(list, searchedId) {
            if (Object.keys(list).length !== 0) {
                const foundItem = list.find(item => item.id === searchedId);
                return foundItem ? foundItem.name : '';
            }
            return '';
        },
        getNumericOptionsForDebt(debt) {
            return {
                readOnly: debt.debt_paid,
                maximumValue: debt.debt >= 0 ? debt.debt : 9999999,
                minimumValue: debt.debt >= 0 ? 0 : debt.debt
            };
        },
        getNumericOptionsForExpense(debt) {
            return {
                readOnly: debt.debt_paid
            };
        },
        handleDebtPaid(debt) {
            debt.amount = debt.debt_paid ? +debt.debt : 0;
        },
        handleAllDebtPaid() {
            this.debts.forEach(d => {
                d.debt_paid = this.allDebtPaid;
                this.handleDebtPaid(d);
            });
        },
        async getIncome() {
            this.loadingMain = true;
            try {
                this.income = await this.$store.dispatch('incomes/getIncome', this.id);
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingMain = false;
            }
        },
        async getDebts(entityType, entityId) {
            if (!this.isNew) {
                return;
            }
            this.loadingDebts = true;
            try {
                this.debts = [];//решает проблему с обновлением значения в auto-numeric
                if (this.isInstallerSelectedNewCard) {
                    this.debts = await this.$store.dispatch('debts/getInstallerDebts', { entityId });
                } else {
                    this.debts = await this.$store.dispatch('debts/getEmployerDebts', { entityId });
                }
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loadingDebts = false;
                this.isSaveButtonPressed = false;
            }
        },
        async createDebtsIncomes() {
            const incomes = this.debts.filter(debt => debt.amount > 0).map(debt => {
                const incomeData = {
                    operation_type_id: this.income.operation_type_id,
                    operation_status_id: this.income.operation_status_id,
                    pay_type_id: this.income.pay_type_id,
                    received_from_type: this.income.received_from_type,
                    received_from_id: this.income.received_from_id,
                    created_by_id: this.income.created_by_id,
                    received_by_type: this.income.received_by_type,
                    received_by_id: this.income.received_by_id,
                    date: this.income.date,
                    deal_id: debt.deal_id,
                    amount: debt.amount,
                    comment: debt.comment
                };
                if (this.income.received_from_type !== this.localReferences.incomeRecievedFromType.employer) {
                    this.incomeData.detail_id = this.income.detail_id;
                }
                return incomeData;
            });
            this.loadingDebts = true;
            try {
                const response = await this.$store.dispatch('incomes/createDebtsIncomes', { incomes });
                const totalAmount = response.data.data.meta.totalAmount;
                const incomesCount = response.data.data.data.length;
                if (totalAmount) {
                    this.showMessage(`Создано ${incomesCount} операций приход на сумму ${totalAmount} руб.`);
                }
                this.income.amount = 0;
                this.getDebts(this.receivedFromType, this.receivedFromId);
            } catch (e) {
                this.setErrorsFromResponse(e.message);
            } finally {
                this.loadingDebts = false;
                this.isSaveButtonPressed = false;
            }
        },
        async getUnaccountedDeals(measurerId) {
            if (!this.isMeasurerSelectedNewCard) {
                return;
            }
            this.loadingDeals = true;
            try {
                this.deals = await this.$store.dispatch('debts/getUnaccountedDeals', { measurerId });
            } catch (e) {
                console.log(e);
            } finally {
                this.loadingDeals = false;
            }
        },
        async createDealIncome(deal) {
            const income = {
                operation_type_id: this.income.operation_type_id,
                operation_status_id: this.income.operation_status_id,
                pay_type_id: this.income.pay_type_id,
                detail_id: this.income.detail_id,
                received_by_type: this.income.received_from_type,
                received_by_id: this.income.received_from_id,
                created_by_id: this.income.created_by_id,
                received_from_type: 'contact',
                date: this.income.date,
                received_from_id: deal.contact_id,
                deal_id: deal.deal_id,
                amount: deal.prepay,
                comment: 'Приход от замерщика'
            };
            this.loadingDeals = true;
            try {
                await this.$store.dispatch('incomes/createDealIncome', { income });
                this.getUnaccountedDeals(this.receivedFromId);
                this.getDebts(this.receivedFromType, this.receivedFromId);
            } catch (e) {
                this.errors = JSON.parse(e.message);
            } finally {
                this.loadingDeals = false;
            }
        },
        async createIncome() {
            this.loadingMain = true;
            try {
                this.income = await this.$store.dispatch('incomes/createIncome', { ...this.income });
                this.goIncomeCard(this.income.id);
            } catch (e) {
                this.errors = JSON.parse(e.message);
            } finally {
                this.loadingMain = false;
                this.isSaveButtonPressed = false;
            }
        },
        async updateIncome() {
            this.loadingMain = true;
            try {
                this.income = await this.$store.dispatch('incomes/updateIncome', { ...this.income });
                this.goIncomeCard(this.income.id);
            } catch (e) {
                this.errors = JSON.parse(e.message);
            } finally {
                this.loadingMain = false;
                this.isSaveButtonPressed = false;
            }
        },
        async createIncomesFromContactToInstaller() {
            const incomes = this.debts.filter(debt => debt.amount !== 0 && debt.installer_balance > 0).map(debt => {
                const garbageRemovalAmount = debt.garbage_removal_exists ? 0 : debt.garbage_removal;
                const additionalWorkAmount = debt.additional_work_exists ? 0 : debt.additional_work;
                const visitAmount = debt.visit_exists ? 0 : debt.visit;
                return {
                    operation_type_id: this.income.operation_type_id,
                    operation_status_id: this.income.operation_status_id,
                    pay_type_id: this.income.pay_type_id,
                    detail_id: localReferences.incomeDetails.install,
                    received_by_type: this.income.received_from_type,
                    received_by_id: this.income.received_from_id,
                    created_by_id: this.income.created_by_id,
                    received_from_type: 'contact',
                    date: this.income.date,
                    received_from_id: debt.contact_id,
                    deal_id: debt.deal_id,
                    amount: debt.amount + debt.salary + garbageRemovalAmount + additionalWorkAmount + visitAmount,
                    comment: 'Приход от клиента, полученный монтажником'
                };
            });
            if (incomes.length === 0) {
                return this.createInstallersDebtsIncomes();
            }
            try {
                const response = await this.$store.dispatch('incomes/createDebtsIncomes', { incomes });
                const totalAmount = response.data.data.meta.totalAmount;
                const incomesCount = response.data.data.data.length;
                if (totalAmount) {
                    this.showMessage(`Создано ${incomesCount} операций Приход от клиента на сумму ${totalAmount} руб.`);
                }
                this.createInstallersDebtsIncomes();
            } catch (e) {
                this.setErrorsFromResponse(e.message);
            } finally {
                this.loadingDebts = false;
            }
        },
        async createInstallersDebtsIncomes() {
            const incomes = this.debts.filter(debt => debt.amount > 0).map(debt => {
                const incomeData = {
                    operation_type_id: this.income.operation_type_id,
                    operation_status_id: this.income.operation_status_id,
                    pay_type_id: this.income.pay_type_id,
                    received_from_type: this.income.received_from_type,
                    received_from_id: this.income.received_from_id,
                    created_by_id: this.income.created_by_id,
                    received_by_type: this.income.received_by_type,
                    received_by_id: this.income.received_by_id,
                    date: this.income.date,
                    deal_id: debt.deal_id,
                    amount: debt.amount,
                    comment: debt.comment
                };
                if (this.income.received_from_type !== this.localReferences.incomeRecievedFromType.employer) {
                    this.incomeData.detail_id = this.income.detail_id;
                }
                return incomeData;
            });
            if (incomes.length === 0) {
                return this.createInstallerDebtsExpenses();
            }
            this.loadingDebts = true;
            try {
                const response = await this.$store.dispatch('incomes/createDebtsIncomes', { incomes });
                const totalAmount = response.data.data.meta.totalAmount;
                const incomesCount = response.data.data.data.length;
                if (totalAmount) {
                    this.showMessage(`Создано ${incomesCount} операций Приход от монтажника на сумму ${totalAmount} руб.`, 50);
                }
                this.income.amount = 0;
                this.createInstallerDebtsExpenses();
            } catch (e) {
                this.setErrorsFromResponse(e.message);
            } finally {
                this.loadingDebts = false;
            }
        },
        async createInstallerDebtsExpenses() {
            const expenses = this.debts.filter(debt => {
                const garbageRemovalAmount = debt.garbage_removal_exists ? 0 : debt.garbage_removal;
                const additionalWorkAmount = debt.additional_work_exists ? 0 : debt.additional_work;
                const visitAmount = debt.visit_exists ? 0 : debt.visit;
                return (debt.salary + garbageRemovalAmount + additionalWorkAmount + visitAmount) > 0 && debt.amount !== 0;
            }).map(debt => {
                const garbageRemovalAmount = debt.garbage_removal_exists ? 0 : debt.garbage_removal;
                const additionalWorkAmount = debt.additional_work_exists ? 0 : debt.additional_work;
                const visitAmount = debt.visit_exists ? 0 : debt.visit;
                let reportDate = '';
                if (debt.contract_date) {
                    const dateSplited = debt.contract_date.split('.');
                    reportDate = dateSplited[2] + '-' + dateSplited[1] + '-' + '01';
                }
                const expense = {
                    pay_type_id: this.income.pay_type_id,
                    detail_id: this.income.detail_id,
                    created_by_id: this.income.created_by_id,
                    source_type: this.income.received_from_type,
                    source_id: this.income.received_from_id,
                    recipient_type: this.income.received_from_type,
                    recipient_id: this.income.received_from_id,
                    date: this.income.date,
                    report_date: reportDate,
                    deal_id: debt.deal_id,
                    amount: debt.salary + garbageRemovalAmount + additionalWorkAmount + visitAmount,
                    comment: 'Расход на монтажника',
                    expense_detail: []
                };
                if (debt.salary > 0) {
                    expense.expense_detail.push({ expense_type: 'salary', amount: debt.salary });
                }
                if (garbageRemovalAmount > 0) {
                    expense.expense_detail.push({ expense_type: 'garbage_removal', amount: garbageRemovalAmount });
                }
                if (additionalWorkAmount > 0) {
                    expense.expense_detail.push({ expense_type: 'additional_work', amount: additionalWorkAmount });
                }
                if (visitAmount > 0) {
                    expense.expense_detail.push({ expense_type: 'visit', amount: visitAmount });
                }
                return expense;
            });
            if (expenses.length === 0) {
                return this.getDebts(this.receivedFromType, this.receivedFromId);
            }
            try {
                const response = await this.$store.dispatch('expenses/createInstallerDebtsExpenses', { expenses });
                const totalAmount = response.data.data.meta.totalAmount;
                const count = response.data.data.data.length;
                if (totalAmount) {
                    this.showMessage(`Создано ${count} операций Расход на сумму ${totalAmount} руб.`, 100);
                }
                this.getDebts(this.receivedFromType, this.receivedFromId);
            } catch (e) {
                console.log(e.message);
            } finally {
                this.isSaveButtonPressed = false;
            }
        },
        formatFinance(num) {
            return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') : 0;
        },
        goIncomeCard(id) {
            this.$router.push({ name: 'income-cash-card-view', params: { id: '' + id } });
        },
        goList() {
            this.$router.push({ name: 'incomes-cash' });
        },
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        },
        handleSelectContact(id) {
            this.selectedContact = this.receivedFromIdList.find(item => item.id === id);
        },
        calculateDebt(debt) {
            debt.debt = debt.installer_balance - debt.salary;
            if (!debt.garbage_removal_exists) {
                debt.debt -= debt.garbage_removal;
            }
            if (!debt.additional_work_exists) {
                debt.debt -= debt.additional_work;
            }
            if (!debt.visit_exists) {
                debt.debt -= debt.visit;
            }
        },
        showMessage(message) {
            this.$notify({ title: 'Успешно', message, type: 'success' });
        },
        setErrorsFromResponse(data) {
            this.isSaveButtonPressed = false;
            const errors = JSON.parse(data);
            this.errors = {
                received_from_type: errors['incomes.0.received_from_type'],
                received_from_id: errors['incomes.0.received_from_id'],
                received_by_type: errors['incomes.0.received_by_type'],
                received_by_id: errors['incomes.0.received_by_id'],
                date: errors['incomes.0.date']
            };
        },
        getDealInfo() {
            return {
                id: this.income.received_from_id,
                name: `${this.income.deal.contract_number} от ${this.income.deal.contract_date}`,
                deal_id: this.income.deal_id,
                contract_number: this.income.deal.contract_number,
                contract_date: this.income.deal.contract_date,
                contact_name: this.income.deal.contact ? this.income.deal.contact.name : '',
                contact_phone: this.income.deal.contact ? this.income.deal.contact.main_phone_number : '',
                address: this.income.deal.address
            };
        }
    },
    watch: {
        receivedByType(value, oldValue) {
            if (value && oldValue && this.income.received_by_id) {
                this.income.received_by_id = null;
            }
            if (oldValue === null && value && this.errors.received_by_type) {
                this.errors.received_by_type = null;
            }
        },
        receivedFromType(value, oldValue) {
            if (oldValue === null && value) {
                if (this.errors.received_from_type) {
                    this.errors.received_from_type = null;
                }
                if (value === 'employer') {
                    this.receivedFromIdList = [...this.employersList];
                    if (!this.isNew && Object.keys(this.income.deal).length) {
                        this.selectedContact = this.getDealInfo();
                    }
                }
                if (value === 'contact' && !this.isNew) {
                    this.receivedFromIdList = [this.getDealInfo()];
                }
            } else if (value && oldValue && this.receivedFromId) {
                this.income.received_from_id = null;
                this.receivedFromIdList = [];
            }
        },
        receivedFromId(value, oldValue) {
            if (oldValue === null && value && this.errors.received_from_id) {
                this.errors.received_from_id = null;
            }
            this.debts = [];
            this.deals = [];
            if (value && this.receivedFromType === 'employer') {
                this.getDebts(this.receivedFromType, this.receivedFromId);
                if (this.isMeasurerSelectedNewCard) {
                    this.getUnaccountedDeals(value);
                }
            }
            if (value && this.receivedFromType === 'contact') {
                this.income.deal_id = this.receivedFromIdList.find(item => item.id === value).deal_id;
                this.selectedContact = this.receivedFromIdList.find(item => item.id === value);
            }
        },
        receivedById(value, oldValue) {
            if (oldValue === null && value && this.errors.received_by_id) {
                this.errors.received_by_id = null;
            }
        },
        amount(value) {
            if (value && this.errors.amount) {
                this.errors.amount = null;
            }
        },
        id(value) {
            if (Number.isInteger(value)) {
                this.getIncome();
            }
        }
    }
};
</script>
